<div class="row align-items-center">
    <div class="col-lg-4"></div>
    <div class="col-lg-4 col-12 col-sm-3 col-md-3">
        <div class="single-partner-item">
            <img src="assets/img/partner/coplus.png" alt="image">
        </div>
    </div>
</div>
